function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import utils from '../../../common/utils/index';
import { cssScrollHelper } from '../../helpers/cssScrollHelper';
import { GalleryComponent } from '../../galleryComponent';

var ScrollIndicator = /*#__PURE__*/function (_GalleryComponent) {
  _inheritsLoose(ScrollIndicator, _GalleryComponent);

  function ScrollIndicator(props) {
    var _this;

    _this = _GalleryComponent.call(this) || this;
    _this.state = {
      scrollTop: 0,
      scrollLeft: 0
    };
    _this.debouncedOnScroll = utils.debounce(props.onScroll, 50);
    return _this;
  }

  var _proto = ScrollIndicator.prototype;

  _proto.removeScrollListener = function removeScrollListener() {
    if (this.scrollEventListenerSet) {
      var scrollingElement = this.props.scrollingElement;

      try {
        scrollingElement.vertical().removeEventListener('scroll', this.onVerticalScroll);
      } catch (e) {//
      }

      try {
        var oneRow = this.props.oneRow;

        if (oneRow) {
          scrollingElement.horizontal().removeEventListener('scroll', this.onHorizontalScroll);
        }
      } catch (e) {//
      }

      this.scrollEventListenerSet = false;
    }
  };

  _proto.initScrollListener = function initScrollListener() {
    var _this2 = this;

    if (this.scrollEventListenerSet) {
      this.removeScrollListener();
    }

    this.scrollEventListenerSet = true;
    var oneRow = this.props.oneRow;
    var scrollingElement = this.props.scrollingElement; //Horizontal Scroll

    this.onHorizontalScroll = function (e) {
      var target = e.currentTarget || e.target || e;
      var top = target && (target.scrollY || target.scrollTop || target.y);
      var left = target && (target.scrollX || target.scrollLeft || target.x);

      if (_this2.props.isRTL) {
        left = _this2.props.totalWidth - left;
      }

      ; // console.log('[RTL SCROLL] onHorizontalScroll: ', left);

      if (left >= 0) {
        if (oneRow) {
          _this2.setState({
            scrollTop: left,
            //todo use both scrollTop and scrollLeft
            scrollLeft: left
          });

          _this2.props.getMoreItemsIfNeeded(left);

          _this2.props.enableScrollPreload();

          _this2.debouncedOnScroll({
            top: top,
            left: left
          });
        }
      }
    };

    try {
      scrollingElement.horizontal().addEventListener('scroll', this.onHorizontalScroll);
    } catch (e) {//
    } //Vertical Scroll


    this.onVerticalScroll = function (e) {
      var target = e.currentTarget || e.target || e;
      var top = target && (target.scrollY || target.scrollTop || target.y);
      var left = target && (target.scrollX || target.scrollLeft || target.x);

      if (_this2.props.isRTL) {
        left = _this2.props.totalWidth - left;
      }

      ; // console.log('[RTL SCROLL] onVerticalScroll: ', left);

      if (top >= 0) {
        if (!oneRow) {
          _this2.setState({
            scrollTop: top
          });

          _this2.props.getMoreItemsIfNeeded(top);

          _this2.props.enableScrollPreload();

          _this2.debouncedOnScroll({
            top: top,
            left: left
          });
        } else {
          _this2.props.setGotFirstScrollIfNeeded();
        }
      }
    };

    try {
      scrollingElement.vertical().addEventListener('scroll', this.onVerticalScroll);
    } catch (e) {//
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeScrollListener();
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initScrollListener();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var didChange = false;

    for (var _i = 0, _arr = ['domId', 'oneRow', 'isRTL', 'totalWidth', 'scrollBase']; _i < _arr.length; _i++) {
      var prop = _arr[_i];

      if (nextProps[prop] !== this.props[prop]) {
        didChange = true;
        break;
      }
    }

    if (didChange) {
      this.initScrollListener();
    }
  };

  _proto.render = function render() {
    var verticalScrollBase = !this.props.oneRow && this.props.scrollBase > 0 ? this.props.scrollBase : 0;
    var scrollTopWithoutBase = this.state.scrollTop - verticalScrollBase;
    var domId = this.props.domId;
    return /*#__PURE__*/React.createElement("div", {
      key: "css-scroll-indicator",
      "data-hook": "css-scroll-indicator",
      "data-scroll-base": verticalScrollBase,
      "data-scroll-top": this.state.scrollTop,
      className: cssScrollHelper.calcScrollClasses(domId, scrollTopWithoutBase),
      style: {
        display: 'none'
      }
    });
  };

  return ScrollIndicator;
}(GalleryComponent);

export { ScrollIndicator as default };